<template>
  <div class="student-score-popover">
    <slot :toggle-visible="toggleVisible"></slot>
    <DataGridDrawer :visible.sync="visible">
      <DialogLayout class="student-score-popover-layout"
                    :title="popoverTitle">
        <StudentCoursePanel :student-id="studentId"
                            :visible="visible"></StudentCoursePanel>
      </DialogLayout>
    </DataGridDrawer>
  </div>
</template>

<script>
import DataGridDrawer from '../../../../../../../elements/grid/DataGridDrawer'
import DialogLayout from '../../../../../../../widgets/DialogLayout'
import AppScrollbar from '../../../../../../../elements/AppScrollbar'
import StudentCoursePanel from '../../../panel/student/course'
export default {
  name: 'StudentScorePopover',
  components: {
    DataGridDrawer,
    DialogLayout,
    AppScrollbar,
    StudentCoursePanel
  },
  props: {
    popoverTitle: {
      type: String,
      default: '学生成绩信息'
    },
    studentId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      visible: false
    }
  },
  methods: {
    toggleVisible () {
      this.visible = !this.visible
    }
  }
}
</script>

<style lang="scss">
  .student-score-popover {
    display: inline-block;
  }
  .student-score-popover-layout {
    max-width: 100%;
    width: 900px;
  }
</style>
